var flkty = new Flickity('.carousel');
console.log(flkty);
var buttonGroup = document.querySelector('.button-group');
var buttons = buttonGroup.querySelectorAll('.button');
buttons = fizzyUIUtils.makeArray(buttons);
buttonGroup.addEventListener('click', function (event) {
  // filter for button clicks
  if (!matchesSelector(event.target, '.button')) {
    return;
  }
  var index = buttons.indexOf(event.target);
  flkty.select(index);
});

// Buttons arrows
let arrowBtns = document.querySelectorAll('.flickity-enabled button');
let carouselArrRt = document.querySelector('.carousel-arrow-right');
let carouselArrLt = document.querySelector('.carousel-arrow-left');
//Parent Container of Flickity Slider
const carouselContainer = document.querySelector('.resp-img-desc-area .carousel');
const checkingChangesInterval = setInterval(() => {
  console.log('Checking for changes');
	const currentContent = carouselContainer.innerHTML;
if (currentContent !== carouselContainer) {
	arrowBtns.forEach(function (button) {
    if (button.classList.contains('next')) {
      button.replaceChild(carouselArrRt, button.querySelector('.flickity-button-icon'));
    } else if (button.classList.contains('previous')) {
      button.replaceChild(carouselArrLt, button.querySelector('.flickity-button-icon'));
    }
  });
initialContent = carouselContainer;
// if above condtion is true then stop interval
  clearInterval(checkingChangesInterval);
}

}
, 1000);
